
import RegisterHero from './components/RegisterHero';
import RegistrationForm from './components/RegistrationForm';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';

export default function Register() {
  return (
    <div>
      <RegisterHero />
      <RegistrationForm />
      <PricingSection />
      <FAQSection />
    </div>
  );
}
